(function () {
  "use strict";

  /* ---------- Mobile menu ---------- */
  var menuBtn = document.getElementById('MenuBtn');
  var navLinks = document.getElementById('NavLinks');
  if (menuBtn && navLinks) {
    menuBtn.addEventListener('click', function () {
      navLinks.classList.toggle('mobile-open');
    });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navLinks.classList.remove('mobile-open');
      });
    });
  }

  /* ---------- Product image gallery ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('#PdpMainImage');
    var thumbs = gallery.querySelectorAll('.pdp-thumb');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var fullSrc = thumb.getAttribute('data-full-src');
        if (mainImg && fullSrc) { mainImg.src = fullSrc; }
      });
    });
  });

  /* ---------- Categories full page ---------- */
  var catPage = document.getElementById('CatPage');
  var categoriesBtn = document.getElementById('categoriesBtn');
  if (catPage && categoriesBtn) {
    var openCatPage = function () {
      catPage.classList.add('open');
      categoriesBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (navLinks) navLinks.classList.remove('mobile-open');
    };
    var closeCatPage = function () {
      catPage.classList.remove('open');
      categoriesBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    categoriesBtn.addEventListener('click', openCatPage);
    var catPageClose = document.getElementById('CatPageClose');
    if (catPageClose) catPageClose.addEventListener('click', closeCatPage);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && catPage.classList.contains('open')) closeCatPage();
    });
  }

  /* ---------- Newsletter popup ---------- */
  var newsletterPopup = document.querySelector('[data-newsletter-popup]');
  if (newsletterPopup) {
    var openNewsletter = function () {
      newsletterPopup.classList.add('open');
      newsletterPopup.setAttribute('aria-hidden', 'false');
    };
    var closeNewsletter = function () {
      newsletterPopup.classList.remove('open');
      newsletterPopup.setAttribute('aria-hidden', 'true');
      try { sessionStorage.setItem('minsthetics_newsletter_dismissed', '1'); } catch (e) {}
    };
    var newsletterClose = newsletterPopup.querySelector('[data-newsletter-close]');
    if (newsletterClose) newsletterClose.addEventListener('click', closeNewsletter);
    document.querySelectorAll('[data-open-newsletter]').forEach(function (el) {
      el.addEventListener('click', openNewsletter);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && newsletterPopup.classList.contains('open')) closeNewsletter();
    });
    var newsletterDismissed = false;
    try { newsletterDismissed = sessionStorage.getItem('minsthetics_newsletter_dismissed') === '1'; } catch (e) {}
    if (!newsletterDismissed) {
      var newsletterShown = false;
      var showNewsletterOnce = function () {
        if (newsletterShown) return;
        newsletterShown = true;
        openNewsletter();
      };
      /* Exit-intent: cursor leaves toward the browser chrome (desktop). */
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && !e.toElement && e.clientY <= 0) showNewsletterOnce();
      });
      /* Scroll depth: they're actually reading (covers mobile, where exit-intent can't fire). */
      window.addEventListener('scroll', function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && (window.scrollY || document.documentElement.scrollTop) / max > 0.5) showNewsletterOnce();
      }, { passive: true });
      /* Fallback so it still appears for a long, slow, no-scroll read. */
      window.setTimeout(showNewsletterOnce, 20000);
    }
  }

  /* ---------- Cart ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  var cartBtn = document.getElementById('cartBtn');

  function openCart() {
    cartDrawer = document.querySelector('[data-cart-drawer]');
    cartOverlay = document.querySelector('[data-cart-overlay]');
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-overlay]')) closeCart();
    if (e.target.closest('[data-close-cart]')) closeCart();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  function refreshCartSections() {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer,header')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data['cart-drawer']) {
          var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var newSection = doc.getElementById('shopify-section-cart-drawer');
          var oldSection = document.getElementById('shopify-section-cart-drawer');
          if (newSection && oldSection) {
            oldSection.innerHTML = newSection.innerHTML;
          }
        }
        if (data['header']) {
          var doc2 = new DOMParser().parseFromString(data['header'], 'text/html');
          var newCount = doc2.getElementById('CartCount');
          var oldCount = document.getElementById('CartCount');
          if (newCount && oldCount) oldCount.textContent = newCount.textContent;
        }
      });
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(function () { return refreshCartSections(); })
      .then(function () { openCart(); });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-variant-id');
      if (variantId) addToCart(variantId, 1);
    }

    var qtyBtn = e.target.closest('[data-change-qty]');
    if (qtyBtn) {
      e.preventDefault();
      var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
      var delta = qtyBtn.getAttribute('data-delta');
      var currentSpan = qtyBtn.parentElement.querySelector('span');
      var currentQty = currentSpan ? parseInt(currentSpan.textContent, 10) : 1;
      var newQty = delta === 'remove' ? 0 : currentQty + parseInt(delta, 10);
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, newQty) }),
      })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshCartSections(); });
    }
  });

  /* ---------- Product form: variant picker ---------- */
  document.querySelectorAll('[data-product-json]').forEach(function (jsonEl) {
    var form = jsonEl.closest('form');
    if (!form) return;
    var variants = JSON.parse(jsonEl.textContent);
    var selects = form.querySelectorAll('[data-product-options]');
    var input = form.querySelector('[data-variant-id-input]');
    var submitBtn = form.querySelector('[data-product-submit]');
    var priceEl = document.getElementById('ProductPrice');

    function currentVariant() {
      var selected = [];
      selects.forEach(function (sel) {
        selected[parseInt(sel.dataset.optionIndex, 10)] = sel.value;
      });
      return variants.find(function (v) {
        return [v.option1, v.option2, v.option3].every(function (opt, i) {
          return selected[i] === undefined || opt === selected[i];
        });
      });
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        var variant = currentVariant();
        if (!variant || !input || !submitBtn) return;
        input.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price_formatted;
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to cart — ' + variant.price_formatted;
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold out';
        }
      });
    });

    form.addEventListener('submit', function (e) {
      if (!input || !input.value) return;
      e.preventDefault();
      addToCart(input.value, 1);
    });
  });
})();
